import React from "react";
import { useTranslation } from "react-i18next";
import { isStandalone } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import StandaloneFeatureNotAvailable from "./StandaloneFeatureNotAvailable";

interface IProps {
    alwaysShow?: boolean;
    imageURI?: string;
}

const UserfulIFrame = (
    props: IProps & React.DetailedHTMLProps<React.IframeHTMLAttributes<HTMLIFrameElement>, HTMLIFrameElement>,
) => {
    const { alwaysShow, src, style, imageURI, ...iframeProps } = props;
    const { t } = useTranslation();

    if (!alwaysShow && isStandalone()) {
        return <StandaloneFeatureNotAvailable style={style} {...iframeProps} imageURI={imageURI} />;
    }

    return <iframe src={src} style={style} {...iframeProps} />;
};

export default UserfulIFrame;
